import React, { useEffect, useState } from "react";
import { Tabs, Table, Button, Search, IconDownload, Select, TextBox, InlineNotification, Toggle } from "@veneer/core";
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Col, Row } from "react-bootstrap";
import XLSX from "xlsx";
import $ from 'jquery';
import ModifyUserView from './ModifyUserData';

const UserView = ( props ) => {
    //Variables
    const [activeTabIndex, setactiveTabIndex] = useState(0);
    const [t, i18n] = useTranslation();
    const connectApi = new ConnectAPI();
    const [dataUV, setDataUV] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [channelView, setChannelView] = useState([]);
    const [channelViewNew, setChannelViewNew] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [channels,setChannels]=useState([]);
    const [regionList] = useState([
        { value: 2, label: 'Brazil' }, { value: 3, label: 'Mexico' },
        { value: 31, label: 'MCA NORTH' }, { value: 32, label: 'MCA SOUTH' },
    ]);

    //Metodos
    const selectTab = () => (index) => {
        setactiveTabIndex(index);
    };
    useEffect(() => {
        //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
                pathname: '/' 
            });
        }
        //end validate
        const fetchData = async () => {
            connectApi.get(
                "api/Channels/UserViewData",
                '',
                dataResponseLoad
            ).catch((error) => {
                setLoadingData(false);
                Swal.fire(
                    "Error " + error.response,
                    error.response,
                    "error"
                );
            });
            setLoadingData(true);
        };
        const dataResponseLoad = (status, data) => {
            data['roles'].forEach(x => { x.idRole = parseInt(x.idRole);});
            data['userViewList'].forEach(x => { x.startdate = x.startdate?moment(x.startdate).format('DD/MMM/YYYY'):moment('01/01/1009').format('DD/MMM/YYYY');});
            const items = data['roles'].map((item) => {
                return { value: item.idRole, label: item.role };
            });
            setRoleList(items);
            const listChanelView = data['userViewList'].map(x => x.customer);
            const listViewFilter = listChanelView.filter((x, idx) => listChanelView.indexOf(x) === idx );
            const listView = listViewFilter.map((item) => { return{ value: listViewFilter.indexOf(item), label: item }; });
            setChannelView(listView);
            setDataUV(data['userViewList'] === undefined ? [] : data['userViewList'] );
            setLoadingData(false)
        };
        const fetchChannels = async () => {
            connectApi.get('api/Channels', '', dataResponseChannel)
            .catch((error) => {
                setLoadingData(false);
                Swal.fire(
                    "Error " + error.response,
                    error.response,
                    "error"
                );
            });
        };
        const dataResponseChannel = (status, data) => {
            setChannels(data);
            const items = data.map((item) => {
                if (item.type != "Inactive"){
                    return{
                        value: item.idCustomer,
                        label: item.name,
                    };
                }
            });
            let channels = items.filter(x => x)
            setChannelViewNew(channels);
        };
        fetchData();
        fetchChannels();
    },[] );
    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if( orderBy === "startdate"  ){
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        } else {
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1;
        }
        return 0;
    }
    function filterSort(array, filters, orderBy, orderType) {
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter)
                arrayFiltered = arrayFiltered.filter((a) => {
                const aUpper = a[value] && a[value].toString().toUpperCase();
                const filterUpper = filter && filter.toString().toUpperCase();
                return aUpper.indexOf(filterUpper) > -1;
                });
            });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }

    //Vistas
    const RenderUserView = () => {
        const [orderBy, setOrderBy] = useState("customer");
        const [orderType, setOrderType] = useState("descending");
        const [endUserFilter, setEndUserFilter] = useState("");
        const [channelFilter, setChannelFilter] = useState("");
        const [channelUV, setChannelUV] = useState();
        const [emailFilter, setEmailFilter] = useState("");
        const [rolelFilter, setRoleFilter] = useState("");
        const [currentPage, setCurrentPage] = useState(1);
        const pageSize = 25;
        const [order, setOrder] = useState([
            'customer',
            'endUser',
            'name',
            'email',
            'active',
            'sendEmailAboutOrders',
            'idCountry',
            'subRegion',
            'role',
            'startdate'
        ]);
        const handlePageChange = (page) => setCurrentPage(page);
        const [showModal, setShowModal] = useState(false);
        const [defaulValues, setDefaulValues] = useState(false);
        const [userSelect, setuserSelect] = useState([]);
        const filteredData = filterSort(
            dataUV, {
                customer: channelFilter,
                endUser: endUserFilter,
                email: emailFilter,
                role: rolelFilter,
            },
            orderBy,
            orderType
        );
        let pagedData = filteredData.slice(
          (currentPage - 1) * pageSize,
          (currentPage - 1) * pageSize + pageSize
        );
        const handleSort = (_, { id, type }) => {
          setOrderBy(id);
          setOrderType(type);
        };
        function setModalParameters(e){
            var email = $(e.target).closest('tr').children().eq(3).text();
            var idCountry = $(e.target).closest('tr').children().eq(6).text();
            var subRegion = $(e.target).closest('tr').children().eq(7).text();
            if( email !== t("Email") & idCountry !== t("Country") & subRegion !== "" & email !== '' ){
                let vaItem = dataUV.find(va => va.email === email & va.idCountry === idCountry & va.subRegion === subRegion );
                setuserSelect(vaItem);
                setShowModal(true);
                setDefaulValues(true);
            }
            
        };
        const handleChange = (name) => (event) => {
            setChannelFilter(event.label);
            setChannelUV([event.value]);
            setCurrentPage(1);
        };
        return (
            <div>
                <Row>
                    <Col 
                        style={{
                            position: "absolute",
                            marginTop: "5px",
                        }}
                    >
                        <div
                            style={{
                                width: '270px',
                            }}
                        >
                            <Select
                                name="customerSearsh"
                                options={channelView}
                                placeholder= {t('select_channel')}
                                value={channelUV}
                                onChange={handleChange()}
                                onClear={() => { setChannelUV(undefined); setChannelFilter(""); }}
                            />
                        </div>
                    </Col>
                </Row>
                <div>
                    <Table
                        onClick={setModalParameters}
                        columns = {[
                            {
                                id: 'customer',
                                label: t("channels")
                            },
                            {
                                id: 'endUser',
                                label: t("endUserName"),
                                filter: (
                                    <Search
                                        id="EndUser-filter"
                                        value={endUserFilter}
                                        onChange={(val) => {
                                            setEndUserFilter(val);
                                            setCurrentPage(1);
                                        }}
                                    />
                                )
                            },
                            {
                                id: 'name',
                                label: t("contactName")
                            },
                            {
                                id: 'email',
                                label: t("Email"),
                                filter: (
                                    <Search
                                        id="email-filter"
                                        value={emailFilter}
                                        onChange={(val) => {
                                            setEmailFilter(val);
                                            setCurrentPage(1);
                                        }}
                                    />
                                )
                            },
                            {
                                id: 'active',
                                label: t("active")
                            },
                            {
                                id: 'sendEmailAboutOrders',
                                label: t("sendMailOrders")
                            },
                            {
                                id: 'idCountry',
                                label: t("Country")
                            },
                            {
                                id: 'subRegion',
                                label: t("Subregion")
                            },
                            {
                                id: 'role',
                                label: t("role"),
                                filter: (
                                    <Search
                                        id="role-filter"
                                        value={rolelFilter}
                                        onChange={(val) => {
                                            setRoleFilter(val);
                                            setCurrentPage(1);
                                        }}
                                    />
                                )
                            },
                            {
                                id: 'startdate',
                                label: t("pricelist.table.dateUpdated")
                            },
                        ]}
                        showFilters
                        columnReorder
                        data={pagedData}
                        loading={loadingData}
                        onSort={handleSort}
                        onColumnReorder={(reOrder) => setOrder(reOrder)}
                        preferences={{
                            defaultOrder: order,
                            sortBy: {
                                id: orderBy,
                                type: orderType,
                            },
                            order: order
                        }}
                        pagination={{
                            currentPage,
                            onPageChange: handlePageChange,
                            pageSize,
                            totalItems: filteredData.length,
                        }}
                    />
                    <div style={{ textAlign: "left" }}>
                        <Button
                            onClick={()=>{
                                setTimeout(() => {
                                const dataXlsx = filteredData.map((item) => { return item; });
                                const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: order });
                                const wb = XLSX.utils.book_new();
                                const date = moment(new Date()).format('YYYYMMDDHHmm');
                                const filename = 'UserViewData-' + date + '.xlsx';
                                const ws_name = "UserViewData";
                                XLSX.utils.book_append_sheet(wb, ws, ws_name);
                                XLSX.writeFile(wb, filename);
                                }, 750);
                            }}
                            disabled={filteredData.length === 0}
                            leadingIcon={<IconDownload />}
                            title={t('download data')}
                        >
                            {t('download')}
                        </Button>
                    </div>
                </div>
                <ModifyUserView
                    showModal={showModal}
                    setShowModal={setShowModal}
                    item={userSelect}
                    fetchData={useEffect}
                    regionList={regionList}
                    roleList={roleList}
                    channelViewNew={channelViewNew}
                />
            </div>
        );
    }
    const AddUserNew = () => {
        const [idEndUser, setIdEndUser] = useState();
        const [idChannel, setIdChannel] = useState();
        const [email, setEmail] = useState("");
        const [idCountry, setIdCountry] = useState("");
        const [role, setRole] = useState([]);
        const [sendMailOrder, setSendMailOrder] = useState(true);
        const [showNotification, setShowNotification] = useState(false);
        const [notificationDetails, setNotificationDetails] = useState({ title: '', type: '', description: '' });
        const [errorChanel, setErrorChanel] = useState(false);
        const [errorEmail, setErrorEmail] = useState(false);
        const [errorCountry, setErrorCountry] = useState(false);
        const [errorRegion, setErrorRegion] = useState(false);
        const [errorRol, setErrorRol] = useState(false);
        const [subregion, setSubregion] = useState({value: []});
        const [endUserView, setEnduserView] = useState([]);
        const [endusers,setEndusers]=useState([]);
        const [activeHP, setActiveHP] = useState(false);
        const [copyView, setCopyView] = useState(channelViewNew);
        const [validator, setValidator] = useState(/^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i);

        const validFormData = () => {
            if( idChannel === undefined || email === '' || subregion.value.length === 0 || role == [] || idCountry === '' ){
                let srt = ": - "
                if(idChannel === undefined ){
                    setErrorChanel(true);
                    srt += t('channel')+" - ";
                }
                if (email === '') {
                    setErrorEmail(true);
                    srt += t('Email')+" - ";
                }
                if (idCountry === '') {
                    setErrorCountry(true);
                    srt += t('Country')+" - ";
                }
                if (subregion.value.length === 0) {
                    setErrorRegion(true);
                    srt += t('Subregion')+" - ";
                }
                if (role == []) {
                    setErrorRol(true);
                    srt += t('role')+" - ";
                }
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("error.gettingData") + srt
                });
                setShowNotification(true);
            } else if ( validatorMail(email) ){
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("eMailErrorFormat")
                });
                setShowNotification(true);
            } else 
                uploadOneDate();
        }//cuando todo acabe all clean crear metodo
        const clearError = () => {
            setErrorChanel(false);
            setErrorEmail(false);
            setErrorCountry(false);
            setErrorRegion(false);
            setErrorRol(false);
        }
        const uploadOneDate = () => {
            let vaItem = dataUV.find(gt => gt.idUser == email  );
            if ( vaItem === undefined | vaItem === '' ){
                let data = new FormData();
                data.append("Action", "NewUserAdd");
                data.append("idCustomer", idChannel);
                data.append("idEndUser", idEndUser===undefined?null:idEndUser);
                data.append("email", email);
                data.append("idCountry", idCountry);
                data.append("idSubRegion", subregion.value);
                data.append("idRole", role);
                data.append("sendEmailAboutOrders", sendMailOrder?1:0);
                const handleUploadResponse = (status, response) => {
                    if (response === 'allGood') {
                        setNotificationDetails({
                            title: t("notifyAllCorrect"),
                            type: 'positive',
                            description: ''
                        });
                        window.location.reload(false);
                    } else 
                        setNotificationDetails({
                            title: t("notifyWrognSQL"),
                            type: 'negative',
                            description: t("notifySQLError")
                        });
                    setShowNotification(true);
                }
                connectApi.post(
                    "api/Channels/uploadUserAdd",
                    data,
                    handleUploadResponse
                ).catch((error) => {
                    Swal.fire(
                        "Error " + error.response.status,
                        error.response.data, "error"
                    );
                });
            }else{
                Swal.fire(
                    "Error ",
                    "User already exists", "error"
                );
            }
            
        }
        const handleChangeSubregions = ({ value }) => {
            const valueCopy = [...subregion.value];
            const isOptionSelected = valueCopy.includes(value);
            if (isOptionSelected) {
              const index = valueCopy.indexOf(value);
              valueCopy.splice(index, 1);
            } else
              valueCopy.push(value);
            
            setSubregion({ value: valueCopy });
        }
        const validatorMail = (value) => {
            let flag = false;
            if( validator.test(value) )
                setErrorEmail(false);
            else{
                flag = true;
                setErrorEmail(true);
            }
            return flag;
        }
        const fetchEndUsers = (channel) => {
            connectApi.get("api/Channels/endUsers",{
                params:{
                    customerId: channel,
                    status: "Active",
                }
            },EndUserListData).catch((error) => {
                Swal.fire(
                    "Error " + error?.response,
                    error?.response,
                    "error"
                );
            });
        };
        const EndUserListData = (status, data) => {
            setEndusers(data);
            const items = data.map((item) => {
                return{
                    value: item.idEndUser,
                    label: item.endUserName,
                };
            });
            setEnduserView(items);
        };
        const updateListEndUser = (val) => {
            let chanselect = channels.find(gt => gt.idCustomer==val.value );
            changeCountry(chanselect["idCountry"]);
            setIdEndUser(undefined);
            setSubregion({value: []})
            setIdChannel([val.value]);
            fetchEndUsers(val.value);
        }
        const updateEndusers=(val)=>{
            let userselect = endusers.find(gt => gt.idEndUser==val.value );


            const valueCopy = [...subregion.value];
            const isOptionSelected = valueCopy.includes(userselect["idServiceArea"]);
            if (isOptionSelected) {
              const index = valueCopy.indexOf(userselect["idServiceArea"]);
              valueCopy.splice(index, 1);
            } else
              valueCopy.push(userselect["idServiceArea"]);
            
            setSubregion({ value: valueCopy });


            setIdEndUser([val.value])
        }
        const changeHP = (val) => {
            if(val){
                setCopyView([{value:"HP", label:"HP"}]);
                setIdChannel(["HP"]);
                setEnduserView([{value:"HP", label:"HP"}]);
                setIdEndUser(["HP"]);
                setValidator( /^[-\w.%+]{1,64}@(HP.com)$/i );
            } else {
                setCopyView(channelViewNew);
                setEnduserView([]);
                setIdChannel(undefined);
                setIdEndUser(undefined);
                setValidator(/^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i);
            }
            setActiveHP(val);
        }
        const changeCountry = (val) => {
            let validator = /^[A-Z]+$/i;
            let str = val+"";
            if(validator.test(str) || val === "")
                setIdCountry(str.toUpperCase());
        }
        return(
            <div style={{ width: "350px", marginLeft:"30%" }}> <br /><br />
                <label>{t("userHP")}</label> <br />
                <Toggle  
                    id="idCondition"
                    onChange={(val) => changeHP(val)}
                /> <br /><br />
                <label>{t('channel')}</label>
                <Select
                    clearIcon={false}
                    value={idChannel}
                    options={copyView}
                    onChange={val => updateListEndUser(val)}
                    placeholder={t('select_channel')}
                    error={errorChanel}
                    disabled = {activeHP}
                /> <br />
                <label>{t('endUserName')}</label>
                <Select
                    clearIcon={false}
                    value={idEndUser}
                    options={endUserView}
                    onChange={(val) => updateEndusers(val) }
                    placeholder={t('selectEndUser')}
                    disabled = {activeHP}
                /> <br />
                <label>{t('new_email')}</label>
                <TextBox
                    id="idEmail"
                    value={email}
                    onChange={(value) => setEmail(value)}
                    error={errorEmail}
                /> <br /><label>{t("Country")}</label>
                <TextBox
                    id="idCountry"
                    maxLength={2}
                    value={idCountry || ''}
                    onChange={(val)=>changeCountry(val)}
                    error={errorCountry}
                /> <br />
                <label>{t("select region")}</label>
                <Select
                    multiple
                    options={regionList}
                    id="idSubRegion"
                    placeholder={t('selectOption')}
                    value={subregion.value}
                    onClear={() => setSubregion({value: []})}
                    onChange={handleChangeSubregions}
                    error={errorRegion}
                /> <br />
                <label>{t("selectRole")}</label>
                <Select
                    clearIcon={false}
                    value={role}
                    options={roleList}
                    onChange={(val) => setRole([val.value])}
                    placeholder={t('selectOption')}
                    error={errorRol}
                /> <br />
                <label>{t("active")}</label> <br />
                <Toggle on={true} id="idactive" />
                <div style={{ marginLeft: '150px', marginTop: '-49px' }} >
                    <label>{t("sendMailOrders")}</label> <br />
                    <Toggle 
                        id="idSendmail"
                        on={sendMailOrder}
                        value={sendMailOrder}
                        onChange={(val) => setSendMailOrder(val)} 
                    /> 
                </div> <br />
                {showNotification ? (
                    <div className="show-animated" style={{ marginBottom: '-12px' }}>
                        <InlineNotification
                            title={notificationDetails.title}
                            type={notificationDetails.type}
                            description={notificationDetails.description}
                            onClose={() => { setShowNotification(false); clearError(); }}
                        /> <br />
                    </div>
                ) : undefined}
                <Button
                    appearance="success"
                    onClick={validFormData}
                > {t("addNewValue")} </Button>
            </div>
        );
    }

    let list = [
        { id: 0, label: t("userAccesView"), content: <div><RenderUserView/></div>},
        { id: 1, label: t("addNewUser"), content: <div><AddUserNew/></div>}
    ];

    return (<>
        <Tabs
            controlId="default"
            onChangeTab={selectTab()}
            selectedTabId={activeTabIndex}
            tabs={list}
        />
    </>);
}

export default UserView;